import React from 'react'
import PropTypes from 'prop-types'
import ContainerFull from '../../components/ContainerFull'
import styled, { css, withTheme } from 'styled-components'
import WidgetOnTourItems from '../../topics/OnTour/widgets/WidgetOnTourItems'
import AdUnit from '../../components/AdUnit'
import BannerBlock from './components/BannerBlock'
import TitleBlock from './components/TitleBlock'
import blockKeys from './keys/blockKeys'
import generateStylingString from '../../modules/generate-styling-string/index.php'

const WrapperContainer = styled(ContainerFull)`
  ${({ margin, pr, theme }) => {
    let cssString = ''

    if (margin && typeof margin === 'object') {
      cssString += generateStylingString(margin, theme)
    }

    if (margin && typeof margin !== 'object') cssString += `margin: ${margin};`
    if (pr) cssString += `background-color: ${theme.color.pr};`

    console.log('Custom CSS:', cssString)

    return css`
      ${cssString}
    `
  }}
`

const Block = ({
  view,
  pr,
  title,
  titleComponent,
  adIds,
  data,
  className,
  margin,
  numberItems,
  autoHide,
  ...props
}) => {
  if (!(view in blockKeys)) {
    return false
  }
  const blockElement = blockKeys[view](props)
  const BlockComponent = blockElement.component
  if (autoHide === undefined) autoHide = blockElement.autoHide
  if (pr === undefined) pr = blockElement.pr
  if (margin === undefined) margin = blockElement.margin
  if ((autoHide && !data) || (data && data.articles && data.articles.length === 0 && view !== 'special_box'))
    return false
  const cinemaColor = data && data['background-color']
  return (
    <WrapperContainer
      id={'ContainerFull'}
      view={view}
      className={className}
      cinemaMode={
        cinemaColor && {
          backgroundPrimary: cinemaColor,
          backgroundSecondary: props.theme.color.background,
        }
      }
      pr={!cinemaColor && pr}
      margin={margin}
      noGapEdge={blockElement.noGapEdge}
      {...props}
    >
      <TitleBlock title={title} />
      {titleComponent}
      {data && data.imageSmall && data.imageLarge && (
        <BannerBlock imageSmall={data.imageSmall} imageLarge={data.imageLarge} url={data.url} />
      )}

      <BlockComponent data={data} adIds={adIds} numberItems={numberItems} pr={!cinemaColor && pr} {...props} />
    </WrapperContainer>
  )
}

Block.propTypes = {
  view: PropTypes.oneOf(Object.keys(blockKeys)).isRequired,
  pr: PropTypes.bool,
  title: PropTypes.node,
  numberItems: WidgetOnTourItems.propTypes.numberItems,
  adIds: PropTypes.arrayOf(AdUnit.propTypes.adId),
  autoHide: PropTypes.bool,
}

Block.defaultProps = {
  view: 'big_article',
}

export default withTheme(Block)
